<template>
  <div class="space-medium">
      <div class="container-fluid">
          <div class="row">
              <div class="offset-xl-2 col-xl-8 offset-lg-2 col-lg-8 col-md-12 col-sm-12 col-12">
                  <div class="section-title text-center">
                      <!-- section title start-->
                      <h2 class="mb10">最新婚禮商戶</h2>
                      <p>A short description for showcase of latest wedding venue. </p>
                  </div>
                  <!-- /.section title start-->
              </div>
          </div>
          <div class="venue-thumbnail-carousel">
              <div class="owl-carousel owl-theme owl-venue-thumb">
                  <div class="item" v-for="merchant in merchants">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                          <div class="vendor-thumbnail">
                              <!-- Vendor thumbnail -->
                              <div class="vendor-img zoomimg">
                                  <!-- Vendor img -->
                                  <a href="#"><img :src="merchant.feature_media_url" alt="" class="img-fluid"></a>
                                  <div class="wishlist-sign"><a href="#" class="btn-wishlist"><i class="fa fa-heart"></i></a></div>
                              </div>
                              <!-- /.Vendor img -->
                              <div class="vendor-content">
                                  <!-- Vendor Content -->
                                  <h2 class="vendor-title"><a href="#" class="title">{{ merchant.name }}</a></h2>
                                  <p class="vendor-address"><span class="vendor-address-icon"><i class="fa fa-map-marker-alt"></i> </span> Ahmedabad, Gujarat.</p>
                              </div>
                              <!-- /.Vendor Content -->
                              <div class="vendor-meta">
                                  <div class="vendor-meta-item vendor-meta-item-bordered">
                                      <span class="vendor-price">
                                  $150
                              </span>
                                      <span class="vendor-text">Start From</span></div>
                                  <div class="vendor-meta-item vendor-meta-item-bordered">
                                      <span class="vendor-guest">
                                  120+
                              </span>
                                      <span class="vendor-text">Guest</span>
                                  </div>
                                  <div class="vendor-meta-item vendor-meta-item-bordered">
                                      <span class="rating-star">
                                  <i class="fa fa-star rated"></i>
                                  <i class="fa fa-star rated"></i>
                                  <i class="fa fa-star rated"></i>
                                  <i class="fa fa-star rated"></i>
                                  <i class="fa fa-star rate-mute"></i>
                                  </span>
                                      <span class="rating-count vendor-text">(20)</span></div>
                              </div>
                          </div>
                          <!-- /.Vendor thumbnail -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "LandingLatestVendor",
  props: {
    msg: String
  },
  data() {
    return {
      merchants: []
    };
  },
  mounted() {
    axios({ method: "GET", "url": "https://api.allaboutwedding.com/funmall/merchant/landing/latest/1" }).then(result => {
      this.merchants = result.data.merchants;
    }, error => {
      console.error(error);
    });
  }
};
</script>
